import Authorization from './Authorization.js'

export default class AuthorizationFilter {

  static _initRoles() {
    this.roles = {
      admin: window.hasRole(Authorization.ROLES.admin),
      user: window.hasRole(Authorization.ROLES.user)
    }
  }

  static viewsAllowed(names) {
    return names.filter(name => this.viewAllowed(name))
  }

  static viewAllowed(name) { // NOSONAR complexity: too many returns
    this._initRoles()
    switch (name) {
      case 'Admin_Parameter':
      case 'Admin_Ml':
      case 'Admin_Tek':
      case 'Admin_Gek':
      case 'Admin_Seg':
      case 'Admin_Export':
      case 'Admin_Audit':
        return this.roles.admin
      case 'Admin':
      case 'Admin_Stammdatenpflege':
      case 'Admin_Angebot_Ego':
      case 'Admin_Angebot_Egz':
      case 'Admin_Angebot_Gaznat':
      case 'Admin_Angebot_Gvm':
      case 'Admin_Angebot_Ail':
      case 'Admin_Monitoring':
      case 'Cockpit':
      case 'Gas':
      case 'Massnahmen':
      case 'Massnahmen_Dch':
      case 'Massnahmen_Chot':
      case 'Massnahmen_Gaznat':
      case 'Massnahmen_Ail':
      case 'Verbrauch':
      case 'Verbrauch_Ch':
      case 'Verbrauch_Chot':
      case 'Verbrauch_Dch':
      case 'Verbrauch_Gaznat':
      case 'Verbrauch_Ail':
      case 'Verbrauch_Ego':
      case 'Verbrauch_Egz':
      case 'Verbrauch_Gvm':
      case '':
        return this.roles.admin || this.roles.user
      default:
        return false
    }
  }

  static _hasRoleAdmin() {
    return window.hasRole(Authorization.ROLES.admin)
  }
}
